import axios from "axios";
import { createContext, useContext } from "react";

export type TenantBranding = {
  logo: string | null;
  primaryColor: string | null;
  secondaryColor: string | null;
  loginBackgroundImage: string | null;
};

export type TenantContextData = {
  tenantId: string | null;
  tenantSlug: string | null;
  tenantName: string | null;
  domain: string;
  /** Whether this tenant's login page offers the "request an account" form. */
  selfSignupEnabled: boolean;
  branding: TenantBranding | null;
};

export const TenantContext = createContext<TenantContextData | null>(null);

/** Resolves the current portal tenant from the backend-owned hostname mapping. */
export const fetchTenantContext = async (): Promise<TenantContextData> =>
  (await axios.get<TenantContextData>("/api/tenant/context")).data;

/** Returns the hostname-resolved tenant available to all portal components. */
export const useTenant = (): TenantContextData => {
  const context = useContext(TenantContext);
  if (!context) throw new Error("useTenant must be used within TenantProvider");
  return context;
};
